module.exports = __webpack_public_path__ + "static/img/06.68b4e5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/06.jpg
// module id = yUal
// module chunks = 0